export const SEGMENT_TYPES = [
  {
    label: 'News Release',
    value: 'News Release',
  },
  {
    label: 'Headline',
    value: 'Headline',
  },
  {
    label: 'In-dept Feature',
    value: 'In-dept Feature',
  },
  {
    label: 'Interview',
    value: 'Interview',
  },
  {
    label: 'News Analysis',
    value: 'News Analysis',
  },
  {
    label: 'Weather',
    value: 'Weather',
  },
];
